import ArrowDownIcon from './arrow-down-icon';

export default ArrowDownIcon;
